// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chain-img-container{position:absolute;margin-top:-26px;margin-left:16px;width:70px}.small-text{font-size:.7rem}.v-card__text,.v-card__title{word-break:normal}.v-card__title{font-size:1.2rem;line-height:1.3rem}", ""]);
// Exports
module.exports = exports;
